import { createReducer, on, Action } from '@ngrx/store';
import { initialState, WishlistState } from './state';
import {
  getGuestWishlist,
  getGuestWishlistSuccess,
  getGuestWishlistFailure,
  addGuestWishlistItem,
  addGuestWishlistItemSuccess,
  addGuestWishlistItemFailure,
  removeGuestWishlistItem,
  removeGuestWishlistItemSuccess,
  removeGuestWishlistItemFailure,
} from './actions';

const reducer = createReducer(
  initialState,

  // LOAD
  on(getGuestWishlist, (state) => ({ ...state, loading: true, error: null })),
  on(getGuestWishlistSuccess, (state, { items }) => ({ ...state, loading: false, items, error: null })),
  on(getGuestWishlistFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // ADD
  on(addGuestWishlistItem, (state) => ({ ...state, loading: true, error: null })),
  on(addGuestWishlistItemSuccess, (state, { item }) => ({ ...state, loading: false, items: [...state.items, item], error: null })),
  on(addGuestWishlistItemFailure, (state, { propertyId, error }) => ({ ...state, loading: false, error })),

  // REMOVE
  on(removeGuestWishlistItem, (state) => ({ ...state, loading: true, error: null })),
  on(removeGuestWishlistItemSuccess, (state, { propertyId }) => ({
    ...state,
    loading: false,
    items: state.items.filter((i) => i.propertyId !== propertyId),
    error: null,
  })),
  on(removeGuestWishlistItemFailure, (state, { propertyId, error }) => ({ ...state, loading: false, error }))
);

export function guestWishlistReducer(state: WishlistState | undefined, action: Action) {
  return reducer(state, action);
}
